import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface FestiveState {
    isFestiveEnabled: boolean
    toggleFestive: () => void
    setFestiveEnabled: (value: boolean) => void
}

export const useFestiveStore = create<FestiveState>()(
    persist(
        (set) => ({
            isFestiveEnabled: true, // Default to true
            toggleFestive: () =>
                set((state) => ({ isFestiveEnabled: !state.isFestiveEnabled })),
            setFestiveEnabled: (value: boolean) =>
                set({ isFestiveEnabled: value }),
        }),
        {
            name: 'festive-storage', // unique name
        }
    )
)
